<div class="supplies">
  <div class="supplies__main">
    <div class="supplies__header">
      <h2>{{ title }}</h2>
      <p *ngIf="subtitle" class="supplies__subtitle">{{ subtitle }}</p>
    </div>

    <div class="supplies__filters">
      <div class="filter-field filter-field--search">
        <label>{{ searchText }}</label>
        <input
          type="text"
          [(ngModel)]="search"
          (keyup.enter)="applyFilters()"
          [placeholder]="searchPlaceholderText"
        />
      </div>
      <div class="filter-field">
        <label>{{ periodText }}</label>
        <div class="filter-field__range">
          <input type="date" [(ngModel)]="dateFrom" (change)="applyFilters()" />
          <span>—</span>
          <input type="date" [(ngModel)]="dateTo" (change)="applyFilters()" />
        </div>
      </div>
      <button type="button" class="btn-secondary" (click)="applyFilters()">{{ applyText }}</button>
      <button type="button" class="btn-link" *ngIf="hasActiveFilters()" (click)="clearFilters()">{{ clearText }}</button>
    </div>

    <div *ngIf="loading" class="loading">{{ loadingText }}</div>
    <div *ngIf="error" class="error">{{ error }}</div>

    <div *ngIf="!loading && !error && calculations.length === 0" class="empty-state">
      <p>{{ emptyText }}</p>
    </div>

    <div *ngIf="!loading && !error && calculations.length > 0" class="supplies-table">
      <table>
        <thead>
          <tr>
            <th>{{ colNumberText }}</th>
            <th>{{ colProductText }}</th>
            <th>{{ colRouteText }}</th>
            <th>{{ colStatusText }}</th>
            <th>{{ colCreatedText }}</th>
            <th>{{ colCostText }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let calc of calculations" class="clickable-row" (click)="onOpen(calc.id)">
            <td>
              <div class="supply-id">№{{ calc.id }}</div>
              <div class="supply-title" *ngIf="calc.title">{{ calc.title }}</div>
            </td>
            <td class="products-cell">
              <div class="products-summary" [title]="getProductsFullText(calc)">{{ getProductsSummary(calc) }}</div>
              <div class="supply-invoice" *ngIf="getInvoiceNumber(calc)">{{ invoiceText }} {{ getInvoiceNumber(calc) }}</div>
            </td>
            <td>
              <ng-container *ngIf="hasRoute(calc); else noRoute">
                <div class="route-line">{{ getRouteFrom(calc) }}</div>
                <div class="route-arrow">↓</div>
                <div class="route-line">{{ getRouteTo(calc) }}</div>
              </ng-container>
              <ng-template #noRoute>—</ng-template>
            </td>
            <td>
              <span class="status-badge" [class.in-processing]="calc.status === 'IN_PROCESSING'" [class.processed]="calc.status === 'PROCESSED'">
                {{ statusLabel(calc.status) }}
              </span>
            </td>
            <td>{{ calc.createdAt | date:'dd.MM.yyyy' }}</td>
            <td>{{ calc.totalProductCostKzt ? (calc.totalProductCostKzt | number:'1.2-2') + ' ₸' : '-' }}</td>
            <td>
              <button type="button" class="btn btn-primary btn-sm" (click)="onOpen(calc.id); $event.stopPropagation()">
                {{ openText }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <app-pagination
        *ngIf="calculationsPage"
        [number]="calculationsPage.number"
        [totalPages]="calculationsPage.totalPages"
        [size]="calculationsPage.size"
        [totalElements]="calculationsPage.totalElements"
        [hasNext]="calculationsPage.hasNext"
        [hasPrevious]="calculationsPage.hasPrevious"
        (pageChange)="onPageChange($event)"
      ></app-pagination>
    </div>
  </div>

  <aside class="supplies__sidebar" *ngIf="!loading && !error && calculations.length > 0">
    <div class="summary-card">
      <h3>{{ summaryTitleText }}</h3>
      <p class="summary-card__count">{{ calculationsPage?.totalElements || calculations.length }} {{ suppliesCountText }}</p>
    </div>

    <div class="summary-card">
      <h3>{{ goodsCostTitleText }}</h3>
      <p class="summary-card__amount">{{ totalGoodsCost | number:'1.2-2' }} ₸</p>
    </div>

    <div class="summary-card">
      <h3>{{ customsPaymentsTitleText }}</h3>
      <p class="summary-card__amount">{{ totalCustomsPayments | number:'1.2-2' }} ₸</p>
    </div>
  </aside>
</div>
